import { TemplateElement, html, i18n } from '@webtides/element-js';
import style from './retailer-search-info-box.css';

export default class RetailerSearchInfoBox extends TemplateElement {
    constructor(options) {
        super({ shadowRender: false, styles: [style], ...options });
    }

    properties() {
        return {
            searchString: '',
        };
    }

    template() {
        return html`
            <div class="box p-8 text-center text-lg font-semibold">
                ${i18n('retailerSearch.infobox.location.label', 'Ihr Standort ist')}
                <b class="mx-2 font-extrabold">${this.searchString}</b>
                <button class="" data-change-input>${i18n('retailerSearch.infobox.location.change', 'ändern')}</button>
            </div>
        `;
    }
}
